class ArticleFixedSidebar extends HTMLElement {
  connectedCallback() {
    const sectionId = this.getAttribute("section-id");
    const root = document.querySelector(`#shopify-section-${sectionId}`);
    if (!root) return;

    const sidebar = root.querySelector('.sc-article-fixedsidebar');
    const openButton = root.querySelector('.sc-article-fixedsidebar-openbutton');

    if (!sidebar || !openButton) return;

    openButton.addEventListener('click', () => {
      const isOpen = sidebar.dataset.open === "true";
      sidebar.dataset.open = isOpen ? "false" : "true";
      openButton.dataset.active = isOpen ? "false" : "true";
    });
  }
}

customElements.define('sc-article-fixedsidebar', ArticleFixedSidebar);

class ArticleTOC extends HTMLElement {
  connectedCallback() {
    const sectionId = this.getAttribute("section-id");
    const root = document.querySelector(`#shopify-section-${sectionId}`);
    if (!root) return;

    const tocLists = this.querySelectorAll('.article-dynamic-menu-list');
    const contentEl = root.querySelector('#article-content');
    const sidebar = root.querySelector('.sc-article-fixedsidebar');
    const openButton = root.querySelector('.sc-article-fixedsidebar-openbutton');

    if (!contentEl || tocLists.length === 0) return;

    const headings = Array.from(contentEl.querySelectorAll('h2, h3, h4'));
    const tocMap = {};

    tocLists.forEach(tocEl => {
      tocEl.innerHTML = ''; 

      headings.forEach(heading => {
        if (!heading.id) {
          const slug = heading.textContent.trim()
            .toLowerCase()
            .replace(/[^\w\- ]+/g, '')
            .replace(/\s+/g, '-');
          heading.id = slug;
        }

        const li = document.createElement('li');
        li.className = heading.tagName.toLowerCase();
        li.innerHTML = `<a href="#${heading.id}">${heading.textContent}</a>`;
        tocEl.appendChild(li);
        tocMap[heading.id] = li;

        li.addEventListener('click', () => {
          if (sidebar && openButton) {
            sidebar.dataset.open = "false";
            openButton.dataset.active = "false";
          }
        });
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          Object.values(tocMap).forEach(li => li.classList.remove('active'));
          const id = entry.target.id;
          if (tocMap[id]) tocMap[id].classList.add('active');
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -80% 0px',
      threshold: 0
    });

    headings.forEach(h => observer.observe(h));
  }
}

customElements.define('sc-article-toc', ArticleTOC);